import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

function tasParticipantsBaseUrl() {
  const opts: QueryUrlOptions = {
    identifier: { type: 'tas-participants' },
    op: 'query',
    resourcePath: 'tas-participants',
  };
  return buildBaseURL(opts);
}

/**
 * PATCH /tas-participants/:id/transition/state/hold
 * Places a TAS participant on hold (pauses their eligibility).
 * The optional changelog is sent as `_changelog` inside `data.attributes`,
 * mirroring what the legacy adapter sent.
 */
export function holdTasParticipantRequest(
  participantId: string,
  changelog?: { note: string }
): RequestInfo {
  return {
    url: `${tasParticipantsBaseUrl()}/${participantId}/transition/state/hold`,
    method: 'PATCH',
    body: JSON.stringify({ data: { attributes: { _changelog: changelog } } }),
    cacheOptions: { [SkipCache]: true },
  };
}

/**
 * PATCH /tas-participants/:id/transition/state/activate
 * Removes a hold on a TAS participant (re-activates their eligibility).
 */
export function activateTasParticipantRequest(
  participantId: string,
  changelog?: { note: string }
): RequestInfo {
  return {
    url: `${tasParticipantsBaseUrl()}/${participantId}/transition/state/activate`,
    method: 'PATCH',
    body: JSON.stringify({ data: { attributes: { _changelog: changelog } } }),
    cacheOptions: { [SkipCache]: true },
  };
}
